import _styled from "styled-components";
const _excluded = ["style", "className", "children", "href", "target", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const A = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      style,
      className,
      children,
      href,
      target,
      onClick
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledA, _extends({
    rel: "noopener noreferrer"
  }, props, {
    ref: ref,
    href: href,
    target: target,
    className: className,
    onClick: onClick,
    $_css: [{
      color: theme.tokens.colors.text.link.value,
      textDecoration: 'none',
      '&:hover': {
        color: theme.tokens.colors.text.hover.value
      },
      '&:active': {
        color: theme.tokens.colors.text.pressed.value
      }
    }, style]
  }), children);
});
A.displayName = 'A';
A.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /**  The component's children */
  children: PropTypes.any,
  /**  href is url string a linked to */
  href: PropTypes.string.isRequired,
  /**  a href target */
  target: PropTypes.string,
  /**  anchor onClick event handler */
  onClick: PropTypes.func
};
export default A;
var _StyledA = _styled("a").withConfig({
  displayName: "A___StyledA",
  componentId: "sc-1nhbr55-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=A.js.map